import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { connect } from 'react-redux';
import { semanticColors, greyScaleColors } from '../../../../Globals/styles';
import {
  dailyReportUpdateDesccription,
  attemptTranslateText
} from './actions';

class Description extends Component{
  isContainerActive = () => {
    return this.props.description.length
  };
  render()  {
    const { dispatch, description, englishDescription } = this.props;
    return (
      <div style={styles.outerContainer}>
        <div className="row" style={[styles.container, this.isContainerActive() && styles.containerActive]}>
          <div className="col-xs-12" style={styles.heading}>
            Beskrivelse
            <button className="btn btn-sm waves-btn" style={styles.translateButton} onClick={() => {dispatch(attemptTranslateText())}}>
              <i className="fa fa-globe fa-lg" style={styles.globe} aria-hidden="true"></i>
              Oversæt til engelsk
            </button>
          </div>
          {englishDescription ? <div style={[styles.colHeading, styles.firstColumn]} className="col-xs-12">Dansk</div> : null}
          <div style={styles.firstColumn} className="col-xs-12">
            <textarea
              style={styles.textarea}
              value={description}
              placeholder="..."
              onChange={(evt) => dispatch(dailyReportUpdateDesccription(evt.target.value))}/>
          </div>
          {englishDescription ?
            <div>
              <div style={[styles.colHeading, styles.firstColumn]} className="col-xs-12">English</div>
              <div style={styles.firstColumn} className="col-xs-12">
                <textarea
                  style={styles.textarea}
                  value={englishDescription}
                  onChange={(evt) => dispatch(dailyReportUpdateDesccription(evt.target.value, 'englishDescription'))}/>
              </div>
            </div>
            :
            null
          }
        </div>
      </div>
    );
  }
}

var styles = {
  outerContainer: {
    margin: '0 0 12px 0',
    paddingRight: '12px'
  },
  container: {
    backgroundColor: greyScaleColors.greyLighter,
    padding: '2px 0 8px 6px',
    margin: '0',
    borderLeft: '2px solid ' + semanticColors.mainBackground
  },
  containerActive: {
    borderLeft: '2px solid ' + semanticColors.info
  },
  firstColumn: {
    paddingLeft: '0'
  },
  heading: {
    marginBottom: '20px',
    paddingLeft: '0',
    position: 'relative'
  },
  textarea: {
    '-webkit-appearance': 'none',  
    display: 'block',
    border: 'none',
    boxShadow: '0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset',
    width: '100%',
    height: '55px',
    resize: 'none',
    borderRadius: '2px',
    paddingLeft: '5px',
  },
  colHeading:{
    fontSize: '12px',
    paddingBottom: '4px',
    textAlign: 'left'
  },
  translateButton: {
    backgroundColor: greyScaleColors.greyLight,
    color: semanticColors.default,
    height: '27px',
    lineHeight: '4px',
    position: 'absolute',
    right: '12px',
    top: '4px'
  },
    globe: {
    fontSize: '21px',
    marginRight: '10px'
  }
}


const selectProps = state => {
  return {
    ...state.dailyReportDescriptionReducer
  };
}
  Description.propTypes = {
    dispatch: PropTypes.func.isRequired,
    description: PropTypes.string.isRequired,
    englishDescription: PropTypes.string
  };
export default connect(selectProps)(Radium(Description));


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Description/index.jsx